module.exports = __webpack_public_path__ + "odstraneni-tetovaze_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_8_before.jpg
// module id = 966
// module chunks = 0